export default __webpack_public_path__ + "static/media/icon-file-xls.098b9e84.svg";